import {getConfigFields} from '../fields.js'
import {formFieldIds} from '../values.js'

const {postalCode, name, email, phone} = formFieldIds

const formC2bUserDataFieldsConfig = [
  getConfigFields[postalCode]({customProps: {help: 'PUBLISH_AD.STANDALONE.FORM.POSTAL_CODE.HELP_TEXT'}}),
  getConfigFields[name]({
    customProps: {
      help: 'FORM.CONTACT_NAME_HELP_TEXT',
      hint: 'FORM.CONTACT_NAME_WITH_NO_SURNAMES_PLACEHOLDER'
    }
  }),
  getConfigFields[phone]({
    customProps: {help: 'INSTANT_OFFER.LANDING.WILL_CONTACT_YOU_IF_ANY_PROBLEM', hint: 'COMMON.FORM_FIELDS.PHONE.HINT'}
  }),
  getConfigFields[email]({
    customProps: {help: 'FORM.CONTACT_EMAIL_CONFIRMATION_HELP_TEXT'}
  })
]

export const formC2bUserDataFormConfig = {
  fields: formC2bUserDataFieldsConfig
}
